var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<div (blocks)>\n\t<div class=\"add\" (add-block)></div>\n</div>\n"}],
    template = twig({"id":"$resolved:9f6bd2bc7c7ef99ab7c9586800245b6caf973fc1840e8c49d74889f045fd0ef6a58d4894cd80e617edcba1f87c8a659f6eb6d289774e9038ec542bbf3d22606b:gmark-editor.twig","data":[{"type":"raw","value":"<div (blocks)>\n\t<div class=\"add\" (add-block)></div>\n</div>\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;